import { render, staticRenderFns } from "./ReceiptPortal.vue?vue&type=template&id=2c1a9bd6&"
import script from "./ReceiptPortal.vue?vue&type=script&lang=ts&"
export * from "./ReceiptPortal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports